// Référence assureur : regex commune aux blocs contrat, véhicule, conducteur et sinistre (alignée avec le back)
export const regexReference = /^[a-zA-Z0-9\-_|/*#+:;,.]{1,50}$/;
export const regexVIN = /^[a-zA-Z0-9]{4,20}$/;
export const regexVINForInput = /^[a-zA-Z0-9]{1,18}$/;
export const regexPermisConduire = /^[a-zA-Z0-9]{1,19}$/;
export const regexCodeSociete = /^\d{8}$/;
export const regexCodeSociete_for_input = /^\d{1,8}$/;
export const regexSirenSiret = /\b\d{14}\b|\b\d{9}\b/;
export const regexSiretForInput = /^\d{1,14}$/;
export const regexMarque = /^[a-zA-Z0-9À-ÿ]{1,50}$/;
export const regexModele = /^.{1,30}$/;
export const regexGenre = /^.{1,10}$/;
export const regexCategorie = /^.{1,6}$/;
export const regexTypeEnergie = /^.{1,2}$/;
export const regexCylindreeCm3 = /^\d{0,16}(\.\d{0,3})?$/;
export const regexCylindreeCm3ForInput = /^\d{0,16}([,.]{0,1})(\d{0,3})?$/;
export const regexPuissanceAdmnNationale = /^\d{0,}$/;
export const regexUUID = /[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}/;
export const regexCodePortefeuille = /^[0-9a-zA-Z\-._]{0,50}$/;
export const regexLibellePortefeuille = /^[A-Za-zÀ-ÖØ-öø-ÿ0-9 ,.'’()/-]{0,150}$/;
export const regexLibelleSociete = /^[A-Za-zÀ-ÖØ-öø-ÿ0-9 ,.'’()/-]{1,38}$/;
export const regexTelephone = /^[0-9]{5,13}$/;
export const regexTelephone_for_input = /^[0-9]{1,9}$/;
export const regexMail = /^[a-zA-Z0-9][a-zA-Z0-9._-]*[a-zA-Z0-9]@[a-zA-Z0-9][a-zA-Z0-9.-]*[a-zA-Z0-9]\.[a-zA-Z]{2,}$/;
export const regexMail_for_input = /^[@a-zA-Z0-9._-]{1,}$/;
// Regexs issues du fichier XSD (liste non exhaustive)
export const RIE_Nom_Type_restriction = /^[A-Za-zÀ-ÿ \-']{1,50}$/;
export const RIE_Prenom_Type_restriction = /^[A-Za-zÀ-ÿ \-']{1,50}$/;
export const RIE_RaisonSociale_restriction = /^[0-9A-Za-zÀ-ÿ\-.'_ ]{1,50}$/;
export const RIE_NumeroImmatriculation_restriction = /^[a-zA-Z0-9\s-]{3,20}$/;
export const RIE_NumeroImmatriculation_restriction_for_input = /^[a-zA-Z0-9\s-]{1,20}$/;
export const RIE_Siren_Type_restriction = /^\d{9}$/;
export const RIE_Siren_Type_restriction_for_input = /^\d{1,9}$/;
export const RIE_CodeNic_Type_restriction = /^\d{5}$/;
export const RIE_CodeNic_Type_restriction_for_input = /^\d{1,5}$/;
// Contrôles suppleméntaires par rapport au XSD pour le numéro de police
export const RIE_NumeroPolice_restriction = /^[-* /A-z0-9]{1,50}$/;
export const RIE_ReferenceMandat_restriction = /^[0-9a-zA-Z\-._]{1,50}$/;
export const RIE_AncienneteCRM_restriction = /^(?:[1-9]|[1-4][0-9]|50)$/;
export const RIE_Debut_Nom_Type_restriction = /^[A-Za-zÀ-ÿ \-']{3,50}$/;
export const regexCodeSocieteInput = /^[A-Za-z0-9]*$/;

// Nouveaux champs souscripteur
export const RIE_Adresse_restriction = /^[A-Za-zÀ-ÖØ-öø-ÿ0-9 ,.'’()/-]{1,38}$/;
export const RIE_CodePostal_restriction = /^[0-9]{2,20}$/;
export const RIE_CodePostal_mask = /^[0-9]{0,20}$/;
export const RIE_Ville_restriction = /^[A-Za-z0-9À-ÿ' .,-]{2,100}$/;
export const RIE_Ville_mask = /^[A-Za-z0-9À-ÿ' .,-]{0,100}$/;
export const RIE_Cedex_restriction = /^[0-9]{0,5}$/;
export const RIE_Telephone_restriction = regexTelephone;
export const RIE_Telephone_mask = /^[0-9]{1,10}$/;
export const RIE_PaysIso2_restriction = /^[A-Z]{0,2}$/;
export const RIE_Mail_restriction =/^[a-zA-Z0-9][a-zA-Z0-9._-]*[a-zA-Z0-9]@[a-zA-Z0-9][a-zA-Z0-9.-]*[a-zA-Z0-9]\.[a-zA-Z]{2,}$/;
export const RIE_Mail_mask = /^[a-zA-Z0-9@._-]{0,85}$/;
export const RIE_code_portefeuille_restriction = /^[0-9a-zA-Z\-._]*$/;
export const REGEX_CodeSociete = /^\d{8}$/;
export const RIE_LieuNaissance_restriction = /^(?:\d{5}|\d{6}|\d{8})$/;
export const RIE_LieuNaissance_mask =/^\d{1,8}$/;

// REGEX pour les immatriculations
export const NOT_ALPHANUM_OR_STAR: string = "[^a-zA-Z0-9*]";
export const REGEX_FORMAT_IMMAT_FNI_1: string =
"^([ 0-9]{1,4})([ A-Z]{1,3})([ 0-9]{1,2}[ A-Z0-9]{0,1})$";
export const REGEX_FORMAT_IMMAT_FNI_2: string =
"^([ 0-9]{1,3})([ A-Z]{1,3})([ 0-9]{1,2}[ A-Z0-9]{0,1})$";
export const REGEX_FORMAT_IMMAT_SIV: string = "^[A-Z]{2}[0-9]{3}[A-Z]{2}$";
export const REGEX_FORMAT_IMMAT_CYCLO: string = "^[A-Z]{1,2}[0-9]{2,3}[A-Z]{1}$";
export const RACINE_SIV_ACTUELLE: string = "ZZ";
